<div class="footer">
    <div class="footerWrapper" *ngIf="!hidden">
        <div class="logoHolder">
            <img src="assets/Lionsgate-Repertory-logo.png" alt="">
        </div>

        <div class="listTitle">
            <div class="left">
                <div class="title">SITE</div>
            </div>
            <div class="right">
                <div class="title">POPULAR TITLES</div>
            </div>
        </div>

        <div class="itemList">
            <div class="left">
                <a [routerLink]="link.url" routerLinkActive="router-link-active" *ngFor="let link of siteLinks">
                    {{link.title}}
                </a>
            </div>
            <div class="right">
                <div class="item"  *ngFor="let link of movieLinks">
                    <a [routerLink]="link.url" *ngIf="link.search == ''" routerLinkActive="router-link-active">
                        {{link.title}}
                    </a>
                    <a (click)="onClick(link)" *ngIf="link.search != ''" routerLinkActive="router-link-active">
                        {{link.title}}
                    </a>
                </div>
            </div>
        </div>

        <div class="legalLinks">
            <a [href]="link.url" *ngFor="let link of legalLinks" target="_blank">{{link.title}} </a>

            <!-- <app-footer-trustarc></app-footer-trustarc> -->
        </div>
        <div class="copyright">
            ®, ™ &amp; © {{year}} Lions Gate Entertainment Inc. and affiliated companies. All rights reserved.
        </div>
    </div>
    <div id=“consent_blackbar”></div>
</div>